import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PfiService } from '../../mock/pfi.service';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-inland-charges-dialog',
  templateUrl: './inland-charges-dialog.component.html',
  styleUrls: ['./inland-charges-dialog.component.scss']
})
export class InlandChargesDialogComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(MatSort) sort: MatSort;
  dataSource = new MatTableDataSource<any>([]);

  warehouses: { id: number, name: string }[] = [];
  selectedWarehouseID: number | 'ALL' = 'ALL';
  private sub: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { pfiId: number },
    private dialogRef: MatDialogRef<InlandChargesDialogComponent>,
    private pfiService: PfiService
  ) {}

  ngOnInit(): void {

    this.sub = this.pfiService.getSplitInland(this.data.pfiId).subscribe(data => {
      this.dataSource.data = data;

      const warehouseMap = new Map<number, string>();
      data.forEach(item => {
        if (!warehouseMap.has(item.warehouseID)) {
          const label = item.warehouseID === 1 ? 'UK' : 'US';
          warehouseMap.set(item.warehouseID, label);
        }
      });

      this.warehouses = Array.from(warehouseMap.entries()).map(([id, name]) => ({ id, name }));

      this.selectedWarehouseID = 'ALL';

      this.applyWarehouseFilter();
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
  }

  applyWarehouseFilter(): void {
    const filterValue = this.selectedWarehouseID;
    this.dataSource.filterPredicate = (data, _) => {
      return filterValue === 'ALL' || data.warehouseID === filterValue;
    };
    this.dataSource.filter = Math.random().toString(); // force refresh
  }

}


